import React, { useContext } from 'react';
import { FilterContext } from '../../context/Filter';

const VehiclePagecard4 = (props) => {
    const { open } = useContext(FilterContext);

    return (
        <div className="rounded-lg overflow-hidden bordet-t-white border">
            <div className="bg-[#2374BF] p-1 text-md  text-white pb-1 pl-2 font-semibold">
                {props.heading}
            </div>

            {props.vcards}
            {props.des}
        </div>
    );
};

export default VehiclePagecard4;
